import JSZip from 'jszip';

export type ExportToFileOptions = {
  contents: string;
  filename: string;
  mimeType: string;
};

// NOTE: Only works when a DOM is available.
// File sizes are constrained by browsers.
export const exportBlobToFile = ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) => {
  if (!document) {
    // Workaround for https://github.com/facebook/jest/issues/12670
    return;
  }
  const anchorElement = document.createElement('a');
  anchorElement.href = URL.createObjectURL(blob);
  anchorElement.download = filename;
  anchorElement.click();
  URL.revokeObjectURL(anchorElement.href);
};

export const exportToFile = ({
  contents,
  mimeType,
  filename,
}: ExportToFileOptions) => {
  const blob = new Blob([contents], {
    type: mimeType,
  });
  exportBlobToFile({ blob, filename });
};

export const createZipFile = async <T extends JSZip.OutputType>({
  files,
  type,
}: {
  files: ExportToFileOptions[];
  type: T;
}) => {
  const zip = new JSZip();

  files.forEach(({ filename, contents }) => {
    zip.file(filename, contents);
  });

  return zip.generateAsync({ type });
};

export const exportToZipFile = async ({
  filename,
  files,
}: {
  filename: string;
  files: ExportToFileOptions[];
}) => {
  const blob = await createZipFile({ files, type: 'blob' });
  exportBlobToFile({ blob, filename });
};
